import { render } from "./InboundReEdit.vue?vue&type=template&id=30e140bb&scoped=true"
import script from "./InboundReEdit.vue?vue&type=script&lang=js"
export * from "./InboundReEdit.vue?vue&type=script&lang=js"

import "./InboundReEdit.vue?vue&type=style&index=0&id=30e140bb&lang=scss&scoped=true"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e140bb"]])

export default __exports__